import { normalizeUri, getThumbnailsUrlsFromList, replaceHtml, toTimeStamp } from '../../../utils/utils';
import { MediaType } from '../../../constants/MediaType';
export function toItem(settings, data) {
  function getIframeSrc(str) {
    const res = str.match(/src="(.+?)"/i);
    return res ? res[1] : '';
  }
  function getTags(tags) {
    if (tags === null || !tags.length) {
      return [];
    }
    return tags.reduce(function (resultTags, tag) {
      if (tag) {
        resultTags.push(tag.tag);
      }
      return resultTags;
    }, []);
  }
  function getId(str) {
    return Number(str.match(/\/videos\/(\d+)/i)[1]);
  }
  const item = {
    id: getId(data.uri),
    name: replaceHtml(data.name),
    description: replaceHtml(data.description),
    link: normalizeUri(data.link),
    iframeSrc: getIframeSrc(data.embed.html),
    embedHtml: data.embed.html,
    tags: getTags(data.tags),
    width: Number(data.width) || 0,
    height: Number(data.height) || 0,
    createdAt: toTimeStamp(data.created_time),
    folderId: null,
    mediaType: MediaType.Video
  };
  if (!data.pictures || !data.pictures.sizes) {
    return item;
  }
  const availableThumbnailsSizes = data.pictures.sizes.map(function (pictureSize) {
    return {
      ...pictureSize,
      url: pictureSize.link
    };
  });
  const urls = getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
  return {
    ...item,
    ...urls
  };
}